// Re-export of the Iconify component (same as cloudfront_ui/src/components/common/iconify)
// Wraps @iconify/react in an MUI Box for sx prop support.

import { forwardRef, type ReactElement, type RefAttributes } from 'react'
import Box from '@mui/material/Box'
import { Icon, addCollection } from '@iconify/react'
import solarIcons from '@iconify-json/solar/icons.json'

// Pre-load the solar collection so icons render without a CDN fetch
addCollection(solarIcons as Parameters<typeof addCollection>[0])

export interface IconifyProps {
  icon: string
  width?: number | string
  sx?: object
  color?: string
  className?: string
  [key: string]: unknown
}

const iconifyClasses = { root: 'iconify-root' }

const IconifyRoot = forwardRef<SVGElement, IconifyProps>(
  function Iconify({ className, width = 20, sx, icon, color, ...other }, ref): ReactElement {
    const baseStyles = { width, height: width, flexShrink: 0, display: 'inline-flex', color } as const

    const renderFallback = (
      <Box
        component="span"
        className={iconifyClasses.root + (className ? ` ${className}` : '')}
        sx={{ ...baseStyles, ...(sx as object) }}
      />
    )

    if (!icon) return renderFallback

    return (
      <Box
        ref={ref as never}
        component="span"
        className={iconifyClasses.root + (className ? ` ${className}` : '')}
        sx={{ ...baseStyles, ...(sx as object) }}
        {...(other as object)}
      >
        <Icon icon={icon as string} style={{ width: width as number | string, height: width as number | string, color: color as string }} />
      </Box>
    )
  },
)

export const Iconify: (props: IconifyProps & RefAttributes<SVGElement>) => ReactElement | null =
  IconifyRoot as unknown as (props: IconifyProps & RefAttributes<SVGElement>) => ReactElement | null
